import React from 'react';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import VariationTag from '../../lego/VariationTag';
import StartingImageButton from '../../lego/StartingImageButton';
import PromptTextArea from '../../lego/PromptTextArea';
import PromptSubmitButton from '../../lego/PromptSubmitButton';
import { useSelector } from 'react-redux';
import { getVariationTarget } from '../../../../../redux/form/selectors';
import PromptCount from '../../../../PromptCount';
import SettingsPanel from '../../../SettingsPanel';
import ErrorArea from '../../lego/ErrorArea';
import s from './PromptInputMobile.scss';
const PromptInputMobile = ({ formAction })=>{
    const variationTarget = useSelector(getVariationTarget);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['count-and-variation-tag']
    }, /*#__PURE__*/ React.createElement(PromptCount, null), variationTarget ? /*#__PURE__*/ React.createElement(VariationTag, {
        deviation: variationTarget,
        showRemoveIcon: true
    }) : /*#__PURE__*/ React.createElement(StartingImageButton, null)), /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement(PromptTextArea, {
        formAction: formAction,
        minRows: 2
    })), /*#__PURE__*/ React.createElement(SettingsPanel, null), /*#__PURE__*/ React.createElement(PromptSubmitButton, {
        formAction: formAction
    }), /*#__PURE__*/ React.createElement(ErrorArea, null));
};
PromptInputMobile.displayName = 'PromptInputMobile';
export default PromptInputMobile;

//# sourceMappingURL=PromptInputMobile.js.map